"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = exports.typeStyles = exports.SPACE_LINE = exports.SPACE = exports.LINE_100_10_CARD = exports.LINE_100_10 = exports.LINE_80_10 = void 0;

var react_1 = require("@emotion/react");

exports.LINE_80_10 = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-bottom: 1px solid var(--gray-80);\n"])));
exports.LINE_100_10 = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid var(--gray-100);\n"])));
exports.LINE_100_10_CARD = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 30px;\n  background-color: white;\n  box-shadow: inset 0 -1px 0 0 var(--gray-200);\n"])));
exports.SPACE = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 8px;\n  background-color: var(--gray-60);\n"])));
exports.SPACE_LINE = react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 8px;\n  background-color: var(--gray-60);\n  border-top: 1px solid var(--gray-100);\n  border-bottom: 1px solid var(--gray-80);\n"])));
exports.typeStyles = {
  LINE_80_10: exports.LINE_80_10,
  LINE_100_10: exports.LINE_100_10,
  LINE_100_10_CARD: exports.LINE_100_10_CARD,
  SPACE: exports.SPACE,
  SPACE_LINE: exports.SPACE_LINE
};

var wrapper = function wrapper(type) {
  return react_1.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 0;\n  margin: 0;\n  ", ";\n"])), exports.typeStyles[type]);
};

exports.wrapper = wrapper;